export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_MODAL_LOGOUT = "SET_MODAL_LOGOUT";
export const SET_CART_ITEM = "SET_CART_ITEM";
export const CLEAR_CART_ITEM = "CLEAR_CART_ITEM";
export const DELETE_CART_ITEM = "DELETE_CART_ITEM";
export const SET_SHOP_DATA = "SET_SHOP_DATA";
export const LOADING_SHOP_DATA = "LOADING_SHOP_DATA";
export const FAILLURE_SHOP_DATA = "FAILLURE_SHOP_DATA";
export const SET_DETAIL_CART = "SET_DETAIL_CART";
export const GET_ERROR_SIGNUP = "GET_ERROR_SIGNUP";
export const HIDEN_ERROR_MESSAGE = "HIDEN_ERROR_MESSAGE";